import { render, staticRenderFns } from "./x-dialog.vue?vue&type=template&id=9d0e24be&scoped=true&"
import script from "./x-dialog.vue?vue&type=script&lang=ts&"
export * from "./x-dialog.vue?vue&type=script&lang=ts&"
import style0 from "./x-dialog.vue?vue&type=style&index=0&id=9d0e24be&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d0e24be",
  null
  
)

export default component.exports